import { Component, OnInit, inject } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import i18n from './translate';
import { PayeeIconComponent } from '../payee-icon/payee-icon.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [PayeeIconComponent, TranslateModule],
})
export class FooterComponent implements OnInit {
  private translate = inject(TranslateService);

  private static translationsLoaded = false;
  currentYear = new Date().getFullYear();

  ngOnInit() {
    if (!FooterComponent.translationsLoaded) {
      for (const [lang, translation] of Object.entries(i18n)) {
        this.translate.setTranslation(lang, translation, true);
      }
      FooterComponent.translationsLoaded = true;
    }
  }
}
